<template>
  <div class="text-white bg-primary" id="contact">
    <div class="carousel-overlay bg-transparent-gradient-inverse" />
    <div class="container py-5">
      <h1 class="display-4 mb-3" ref="contact">Contact</h1>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="card card-light text-secondary">
            <div class="card-header font-weight-bold">
              Pop your details in here!
            </div>
            <div class="card-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-sm-12">
                    <input
                      type="text"
                      ref="name"
                      name="name"
                      value=""
                      placeholder="Name"
                      class="form-control"
                    />
                    <input type="text" style="display: none;" ref="lastname" name="lastname" />
                  </div>
                </div>
				<div class="form-row">
                  <div class="form-group col-sm-12">
                    <input
                      type="text"
                      ref="propaddress"
                      name="propaddress"
                      value=""
                      placeholder="Property Address"
                      class="form-control"
                    />
                    <input type="text" style="display: none;" ref="lastname" name="lastname" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-sm-6">
                    <input type="hidden" ref="address" name="address" />
                    <input
                      type="text"
                      ref="email"
                      name="email"
                      value=""
                      placeholder="Email"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-6">
                    <input
                      type="text"
                      ref="phone"
                      name="phone"
                      value=""
                      placeholder="Mobile"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12 col-lg-4">
                    <strong>I feel like a</strong>
                  </div>
                  <div class="form-group col-md-6 col-lg-4">
                    <div class="form-check ml-3">
                      <input
                        type="radio"
                        ref="coffee"
                        name="beverage[]"
                        value="coffee"
                        class="form-check-input"
                        checked
                      />
                      <label for="" class="form-check-label text-primary">
                        <span class="fa fa-coffee"></span> Coffee
                      </label>
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-lg-4">
                    <div class="form-check ml-3">
                      <input
                        type="radio"
                        ref="beer"
                        name="beverage[]"
                        value="beer"
                        class="form-check-input"
                      />
                      <label for="" class="form-check-label text-primary">
                        <span class="fa fa-beer"></span> Beer
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-sm-12">
                    <textarea
                      name="message"
                      class="form-control"
                      ref="message"
                      placeholder="Message"
                      rows="1"
                    ></textarea>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group-12">
                    <button
                      class="btn btn-primary btn-block"
                      ref="submitButton"
                      type="button"
                      @click="sendEmail()"
                    >
                      Send
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="ml">
            <h5 class="font-weight-bold mt-4">
              <span class="fa fa-fw fa-phone"></span> Contact Us
            </h5>
            <p><a class="text-white" href="tel:1300044663">1300 044 663</a></p>
            <h5 class="font-weight-bold mb-3">
              <span class="fa fa-fw fa-thumbs-up"></span> Follow Us
            </h5>
            <p>
              <a href="https://www.facebook.com/bricksamortar/?ref=br_rs " target="_blank"
                ><span class="fab text-white fa-fw fa-2x fa-facebook"></span
              ></a>
              <a href="https://www.instagram.com/bricksamortar/?hl=en " target="_blank"
                ><span class="fab text-white fa-fw fa-2x fa-instagram"></span
              ></a>
              <a href="https://www.youtube.com/channel/UCmR2bHt2XdsT-O4VQLTQDxA" target="_blank"
                ><span class="fab text-white fa-fw fa-2x fa-youtube-square"></span
              ></a>
            </p>
          </div>
          <p>
            <a
              class="btn btn-primary m-2"
              href="https://my.propertyme.com/portfolio?code=BRIANQMK"
              target="_blank"
              >Tenant Portal</a
            >
            <a class="btn btn-primary m-2" href="/pdfs/tenancy-application.pdf" target="_blank"
              >Property Application</a
            >
            <a class="btn btn-primary m-2" href="/pdfs/landlord-instructions.pdf" target="_blank"
              >Landlord Instructions</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#contact {
  position: relative;
  background-image: url("../assets/contact.jpg");
  background-size: cover;
  .container {
    position: relative;
    z-index: 9;
    max-width: 1200px;
  }
}
</style>

<script>
import axios from "axios";
import querystring from "querystring";

export default {
  methods: {
    sendEmail() {
      this.$refs.submitButton.classList = "btn btn-block btn-warning";
      this.$refs.submitButton.innerHTML = '<i class="fa fa-spin fa-spinner"></i> Sending..';
      // honeypot
      if (!this.$refs.lastname.value && !this.$refs.address.value) {
        // not a bot
        if (
          this.$refs.name.value == "" ||
          this.$refs.propaddress.value == "" ||
          this.$refs.email.value == "" ||
          this.$refs.phone.value == "" ||
          this.$refs.message.value == ""
        ) {
          this.$refs.submitButton.classList = "btn btn-block btn-danger";
          this.$refs.submitButton.innerHTML = '<i class="fa fa-times"></i> Please fill in required fields';
          setTimeout(() => {
            this.$refs.submitButton.classList = "btn btn-block btn-primary";
            this.$refs.submitButton.innerHTML = "Send";
          }, "3000");
        } else {
          // all fields input
          axios
            .post(
              "/scripts/sendEmail.php",
              querystring.stringify({
                name: this.$refs.name.value,
                propaddress: this.$refs.propaddress.value,
                phone: this.$refs.phone.value,
                email: this.$refs.email.value,
                beverage: this.$refs.beer.checked ? "Beer" : "Coffee",
                message: this.$refs.message.value
              })
            )
            .then(response => {
              if (response.error) {
                this.$refs.submitButton.classList = "btn btn-block btn-success";
                this.$refs.submitButton.innerHTML =
                  '<i class="fa fa-check"></i> Thanks for reaching out!';
              } else {
                this.$refs.submitButton.classList = "btn btn-block btn-success";
                this.$refs.submitButton.innerHTML =
                  '<i class="fa fa-check"></i> Thanks for reaching out!';
              }
            })
            .catch(() => {
              this.$refs.submitButton.classList = "btn btn-block btn-danger";
              this.$refs.submitButton.innerHTML =
                '<i class="fa fa-times"></i> Could not send email at this time';
            });

        }
      }
    }
  }
};
</script>
